import type { ReactNode } from 'react';
import { StudioShell } from '../../layouts/StudioShell.tsx';

/**
 * AppShell — wraps the app in the Studio layout shell. The multi-theme
 * picker was removed; Studio is the locked-in look for pilot. Other
 * shells (EditorialShell, UtilityShell) remain in the repo but are no
 * longer selectable.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return <StudioShell>{children}</StudioShell>;
}
